import { ExclamationTriangle } from 'react-bootstrap-icons';

import { SDSFlexbox } from '@repo/sds/SDSFlexbox';
import { SDSIcon } from '@repo/sds/SDSIcon';
import { SDSText } from '@repo/sds/SDSText';

import { DangerZoneWrapper } from '../DangerZoneWrapper/DangerZoneWrapper';

import './ErrorMessage.scss';

export function ErrorMessage() {
  return (
    <DangerZoneWrapper>
      <SDSFlexbox className="ErrorMessage" direction="column" gap="card-medium" alignItems="center">
        <SDSIcon color="alert" icon={<ExclamationTriangle />} size="large" />
        <SDSText color="alert" type="h5" text="Something went wrong" />
        <SDSText
          type="body-large"
          align="center"
          text="We're sorry. Please try refreshing the page or coming back later. Our team has been notified and is working to resolve the issue. If the problem persists, feel free to contact support for assistance."
        />
      </SDSFlexbox>
    </DangerZoneWrapper>
  );
}
